const Toolbar = () => <p>Tool bar</p>

export default Toolbar
